<template>
  <SnackBar ref="snackbar" />
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-if="encerrado != 'Encerrado'" #activator="{ props }">
      <v-btn prepend-icon="mdi-cancel" color="red" v-bind="props">
        Encerrar Projeto
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Encerrar Projeto: {{ sigla }}
      </v-card-title>

      <v-card-text>
        Você tem certeza que deseja encerrar este projeto?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" dark @click="dialog = false">Não</v-btn>
        <v-btn color="blue darken-1" dark @click="submitForm">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    sigla: {
      type: String,
      required: true,
    },
    encerrado: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
  }),
  components: {
    SnackBar,
  },
  methods: {
    async submitForm() {
      try {
        await axios.patch(
          `${API_URL}/projetos/${this.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.$refs.snackbar.showSuccessSnackbar(
          'Concluído!',
          'Projeto encerrado com sucesso!',
        );
        location.reload();
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
